import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SelectPile from '../SelectPile';
import ContextMenu from '../ContextMenu';
import { selectChoosingEnergies, selectChosenBenchPosition, selectEnergyAttachmentIds } from './selectors';
import { chooseBenchPosition, retreat } from './actions';
import { RETREAT } from '../ActiveGame/contextMenuTypes';
import { selectActivePokemon, selectBench } from '../ActiveGame/selectors';

/** Choosing which attached energy pays the retreat cost. */
const RetreatContextMenu = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const choosingEnergies = useSelector(selectChoosingEnergies);
  const energyAttachmentIds = useSelector(selectEnergyAttachmentIds);
  const chosenBenchPosition = useSelector(selectChosenBenchPosition);
  const bench = useSelector((state) => selectBench(state, { userId }));

  if (!choosingEnergies || !activePokemon) {
    return null;
  }

  const count = activePokemon.getIn(['card', 'retreat_cost']);
  const energy = count === 1 ? 'the energy' : `${count} energy cards`;
  const switchingIn = chosenBenchPosition === null ? null
    : bench && bench.get('cards').find(card => card.get('order') === chosenBenchPosition);
  const done = (ids) => {
    dispatch(chooseBenchPosition(ids));
    if (chosenBenchPosition !== null) {
      dispatch(retreat(chosenBenchPosition));
    }
  };

  return (
    <ContextMenu menu={RETREAT} userId={userId} title="Retreat">
      <SelectPile
        cardsOrCardables={activePokemon.get('energyAttachments')}
        message={switchingIn
          ? `Choose ${energy} to discard, and ${switchingIn.get('name', 'your benched Pokémon')} switches in.`
          : `Choose ${energy} to discard, then pick who switches in.`}
        selectCount={count}
        selectedIds={energyAttachmentIds}
        onSelectDone={done}
      />
    </ContextMenu>
  );
};

RetreatContextMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default RetreatContextMenu;
